// Single source of truth for broadcast merge tags. Both server
// (`apps/server/src/_platform/email/merge-tag-registry.ts`, which adds a
// `resolve` resolver) and web (`apps/web/src/components/broadcasts/MergeTag.ts`,
// the TipTap node; the Direct message composer's "Insert first name") import
// from this file. Adding a new merge tag is one entry here; both sides pick
// it up via TypeScript.
//
// Two representations of the same tag:
//   - in a ProseMirror body doc, a `mergeTag` inline node (`attrs.name`);
//   - in plain text (email subjects, Direct message bodies), the token
//     `{{name}}` — `mergeTagToken` writes it, `splitMergeTagTokens` reads it.
export const MERGE_TAG_NAMES = ['first_name'];
export const MERGE_TAG_LABELS = {
    first_name: 'First name',
};
export function isKnownMergeTag(name) {
    return MERGE_TAG_NAMES.includes(name);
}
export function mergeTagToken(name) {
    return `{{${name}}}`;
}
// Splits plain text into literal runs and merge-tag tokens, in order.
// Adjacent literal text is never split into two segments.
export function splitMergeTagTokens(text) {
    // Splitting on a capturing pattern alternates literal runs (even indexes)
    // with the captured `{{name}}` tokens (odd indexes).
    return text.split(/(\{\{[a-z_]+\}\})/).flatMap((part, index) => {
        if (index % 2 === 0)
            return part.length > 0 ? [{ kind: 'text', text: part }] : [];
        const name = part.slice(2, -2);
        return [isKnownMergeTag(name) ? { kind: 'tag', name } : { kind: 'unknown', token: part, name }];
    });
}
//# sourceMappingURL=merge-tags.js.map